// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3epr3","image":"style_image__1GIog","spin":"style_spin__1ZbPr","method":"style_method__35iJo","fill-1":"style_fill-1__3iAbW"};